import { combineReducers } from "redux";
import createNamedWrapperReducer from "@redux/feature/Markets/Common/Reducers/wrapperReducer";
import SubscriptionFeeReducer from "./subscriptionRate";
import { ERevampReportReducers } from "@adapters/presenters/action-interfaces/Reports/common/CommonReportInterfaces";
export default combineReducers({
    SubscriptionFee: createNamedWrapperReducer(SubscriptionFeeReducer, ERevampReportReducers.SUBSCRIPTION_FEE),
});
